import React from 'react';
import OrderList from '../components/OrderList';

export default function ProcessingOrders() {
  return (
    <OrderList
      status="processing"
      title="调度处理中工单"
      desc="调度已填写处理思路并实操跟进的工单；邮件匹配后流转至待客服处理，由客服/销售查看回复"
    />
  );
}
